module.exports = __webpack_public_path__ + "static/assets/footer.ade6df94.png";